import { render, staticRenderFns } from "./onlineTestStudentMarks.html?vue&type=template&id=43f0e24a&external"
import script from "./onlineTestStudentMarks.vue?vue&type=script&lang=js"
export * from "./onlineTestStudentMarks.vue?vue&type=script&lang=js"
import style0 from "./onlineTestStudentMarks.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports